import history from '../../../../history';
import { extractDataFromArray, extractNameFromArray, showFormatedDate, showFormattedTime, showFormatedDateandTime } from '../../../../actions/utilAction';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { createClaimAction, getAppointmentById, getMasterData, getSoapAction, saveEncounterSigns, savePatientSoapAction, updateServiceCodeBlockedUnits } from './actions/soapActions';
import { getPatientProfileDetails } from '../../../patients/actions/PatientActions';
import React, { Component } from 'react';
import { renderCheckBox, renderTimePicker, renderTextField, renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { getAppConfigList, getGeoLocation } from '../../../AppConfig/actions';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import PatientInfo from '../../../patients/patient_info';
import ProblemModal from './soap_daignosisModal';
import CPTModal from './soap_CPTModal';
import SignatureModal from './signature_modal';
import Alert from 'react-s-alert';

const validate = (values) => {
  const errors = {};

  if (!values.IndividualsPresentId) {
    errors.IndividualsPresentId = 'Please select individuals present';
  }
  if (!values.OtherClinicalServiceNotes) {
    errors.OtherClinicalServiceNotes = 'Please enter other notes';
  }
  if (!values.OtherTestsAdministeredNotes) {
      errors.OtherTestsAdministeredNotes = 'Please enter other notes';
  }
  return errors;
};

class SessionNotes_DiagnosticEvaluation_SOAR extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      fixedHeader: true,
      height: '200px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      appointmentDate: '',
      appointmentTime: '',
      staffName: '',
      patientName: '',
      appointmentTypeName: '',
      appointmentTypeIsBillable: false,
      serviceFacility: '',
      isDirectService: false,
      genderID: null,
      diagnosisArray: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      master_CPT: props.master_data.masterCPT ? props.master_data.masterCPT : [],
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      signatureStaffs: [],
      timeDifference: 0.0,      
      // isAdminUpdateAfterRendered: false,

      // checkbox handling
      isClinicalServiceCheckAllowed: true,
      isTestsAdministeredAllowed: true,      
      isTestAdministeredSeviceCodes: false,
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.renderDiagnosis = this.renderDiagnosis.bind(this);
    this.renderCpt = this.renderCpt.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCompleteSoap = this.onCompleteSoap.bind(this);    
  };

  componentWillMount() {
    this.props.getMasterData();
    // this.props.getPatientDetailsById(this.state.patient_id);
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    this.props.getAppConfigList();
  }

  handleCancel() {
    history.push('/scheduling');
  }

  formatedSoapData(soapDetail) {
    if (soapDetail) {
      let soapObj = soapDetail.data;
      // bind appointment data .....
      let appointmentData = soapObj.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
      });
      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      // let appointmentTime = `${formattedStartTimehours}:${appointmentData.StartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${appointmentData.EndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;
      if (!appointmentTypeIsBillable) {
        this.setState({ isAllSigned: true });
      }
      // to get the patient info panel ..
      if (appointmentData.patientID) {
        this.props.getPatientProfileDetails(appointmentData.patientID);
      }

      this.setState({
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        appointmentTypeName: appointmentTypeName,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId ? true : false,
        signatureStaffs: signatureStaffs,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
        timeDifference: appointmentData.timeDifference,        
      }, () => {
        if (soapObj.id && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
          // this.setState({
          //   serviceStartTime: soapObj.startDateTime,
          //   serviceEndTime: soapObj.endDateTime,
          // });
        }
        let icdArray = [];
        if (soapObj.patientEncounterDiagnosisCodes && soapObj.patientEncounterDiagnosisCodes.length) {
          soapObj.patientEncounterDiagnosisCodes.forEach((obj, index) => {
            icdArray.push({
              'DiagnosisDate': moment(obj.diagnosisDate).format(),
              'Description': obj.description,
              'ICDCodeId': obj.icdCodeId,
              'ICDCode': obj.icdCode,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
            });
          });
          this.setState({
            diagnosisArray: icdArray,
          });
        }
        let cptArray = [];
        if (soapObj.patientEncounterServiceCodes && soapObj.patientEncounterServiceCodes.length) {
          soapObj.patientEncounterServiceCodes.forEach((obj, index) => {
        
            if( obj.serviceCode === '96136' || obj.serviceCode === '96137')
            {
              this.setState({isTestAdministeredSeviceCodes: true })
            }

            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
            });
          });
        }
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isGuardianSigned = true;
              this.setState({ GuardianSign: data });
            }
            if (signObj.patientSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: this.state.patientName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isClientSigned = true;
              this.setState({ ClientSign: data });
            }
            if (signObj.clinicianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: this.state.staffName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isEmployeeSigned = true;
              this.setState({ EmployeeSign: data });
            }
          });
        }
        if ((soapObj.status || '').toLowerCase() === 'rendered') {
          if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            this.setState({ isSoapCompleted: true, isAllSigned: true });
          } else {
            this.setState({ isAllSigned: true });
          }
        }
        if (!this.filter.isGuardianSigned) {
          let employee_signRequired = this.state.signRequired.employee_sign,
            client_signRequired = this.state.signRequired.client_sign,
            guardian_signRequired = this.state.signRequired.guardian_sign;
          if (appointmentData && !appointmentData.isDirectService && this.state.signRequired.guardian_sign) {
            guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
          }

          this.setState({
            signRequired: {
              employee_sign: employee_signRequired,
              client_sign: client_signRequired,
              guardian_sign: guardian_signRequired,
            },
          }, () => {
            this.setState({
              isAllSigned: this.checkIsAllRequiredSigned(),
            });
          });
        }
        this.setState({
          isAllSigned: this.checkIsAllRequiredSigned(),
          get_soap: soapDetail.data,
          CPTTableData: cptArray,
          diagnosisArray: icdArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
        });
      });
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,
      });
    }
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      let client_signRequired = false;
      let guardian_signRequired = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
              case 'CLINICIAN_SIGN':
                employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'PATIENT_SIGN':
                client_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'GUARDIAN_SIGN':
                guardian_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              default:
                break;
            }
          }
        });
      }

      if (!this.filter.isGuardianSigned) {
        // let isAnySignRequired = employee_signRequired || client_signRequired || guardian_signRequired;
        let patientAppointmentData = this.state.get_soap && this.state.get_soap.patientAppointment;
        // let isAppointmentRendered = this.state.get_soap && (this.state.get_soap.status || '').toLowerCase() === 'rendered';
        if (patientAppointmentData && !patientAppointmentData.isDirectService && guardian_signRequired) {
          guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
        }
        this.setState({
          // isAllSigned: !isAnySignRequired,
          signRequired: {
            employee_sign: employee_signRequired,
            client_sign: client_signRequired,
            guardian_sign: guardian_signRequired,
          },
        }, () => {
          this.setState({
            isAllSigned: this.checkIsAllRequiredSigned(),
          });
        });
      }
    }

    if (nextProps.saved_soap && this.props.saved_soap !== nextProps.saved_soap) {
      if (nextProps.saved_soap.id) {
        if (!this.state.encounterId) {
          history.push(`/session-note-diagnosticevaluation-soar/${this.state.apptid}/${nextProps.saved_soap.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        } else {
          this.setState({ isSoapCompleted: true });
        }
        this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: this.state.appointmentTypeIsBillable ? true : false });
      }
    }
    
    // if(this.props.match.params.encId > 0 && nextProps.IsTreatmentGoal !== this.props.IsTreatmentGoal){
    //    this.setState({IsTreatmentGoal: nextProps.IsTreatmentGoal || 0 },()=>{this.changeIsTreatmentGoal(null,nextProps.IsTreatmentGoal || 0)});      
    // }

    if (nextProps.get_soap && this.props.get_soap !== nextProps.get_soap) {
      this.formatedSoapData(nextProps.get_soap);
    }

    if (nextProps.saved_EncounterSigns && nextProps.saved_EncounterSigns !== this.props.saved_EncounterSigns) {
      let signObj = nextProps.saved_EncounterSigns.data;
      if (signObj.guardianSign) {
        let data = this.state.GuardianSign;
        data.id = signObj.id;
        this.setState({ GuardianSign: data });
      }
      if (signObj.patientSign) {
        let data = this.state.ClientSign;
        data.id = signObj.id;
        this.setState({ ClientSign: data });
      }
      if (signObj.clinicianSign) {
        let data = this.state.EmployeeSign;
        data.id = signObj.id;
        this.setState({ EmployeeSign: data });
      }
    }

  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  onCompleteSoap(formProps) {
    this.setState({ isGenerateClaimAfterRendered: false });
    let isGenerateClaim = true;
    this.submitFormData(formProps, isGenerateClaim);
  }

  onSubmit(formProps) {
    this.submitFormData(formProps);
  };

  submitFormData(formProps, isGenerateClaim = false) {
    if (!this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length) {
      Alert.warning('Please add atleast one diagnosis!', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }
    if (this.state.appointmentTypeIsBillable) {
      if (!this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length) {
        Alert.warning('Please add atleast one service code!', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }

    let ICDArray = this.state.diagnosisArray;
    let CPTcodes = this.state.CPTTableData;
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      // 'LocationID': this.props.singleEncounter.locationID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      // 'PatientSign': this.state.ClientSign.Bytes,
      // 'PatientSignDate': this.state.ClientSign.Date,
      // 'ClinicianSign': this.state.EmployeeSign.Bytes,
      // 'ClinicianSignDate': this.state.EmployeeSign.Date,
      // 'GuardianSign': this.state.GuardianSign.Bytes,
      // 'GuardianSignDate': this.state.GuardianSign.Date,
      // 'GuardianName': this.state.GuardianSign.Name,
      'NotetypeId': 6,
      'SessionNotes_DiagnosticEvaluation_SOAR': {
        'Id': this.state.get_soap && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR ? this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.id : 0,
        'IndividualsPresentId': formProps.IndividualsPresentId,      
        'DiagnosticEvaluation_ClinicalService_SOAR': {
          'ClinicalServiceSessionId': this.state.get_soap && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR ? this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR ? this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.id : 0,
          'ClinicalInterview': formProps.ClinicalInterview || 0,
          'RecordsReview': formProps.RecordsReview || 0,
          'TestAdministration': formProps.TestAdministration || 0,
          'TestScoring': formProps.TestScoring || 0,
          'ReportWriting': formProps.ReportWriting || 0,
          'FeedbackWithCaregiver': formProps.FeedbackWithCaregiver || 0,
          'ConsultationWithProvider': formProps.ConsultationWithProvider || 0,
          'OtherCareCoordination': formProps.OtherCareCoordination || 0,
          'OtherPreparationAndInterpretation': formProps.OtherPreparationAndInterpretation || 0,
          'OtherClinicalService': formProps.OtherClinicalService || 0,
          'OtherClinicalServiceNotes': formProps.OtherClinicalService ? formProps.OtherClinicalServiceNotes : '',
        },
        'DiagnosticEvaluation_TestsAdministered_SOAR': {
          'TestsAdministeredId': this.state.get_soap && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR ? this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR ? this.state.get_soap.sessionNotes_DiagnosticEvaluation_SOAR.id : 0,
          'Mullen': formProps.Mullen || 0,
          'WISC_V': formProps.WISC_V || 0,
          'ADOS_2': formProps.ADOS_2 || 0,
          'Vineland_3': formProps.Vineland_3 || 0,
          'BASC_3': formProps.BASC_3 || 0,
          'SRS_2': formProps.SRS_2 || 0,
          'ADI_R': formProps.ADI_R || 0,
          'OtherClinicalInterview': formProps.OtherClinicalInterview || 0,
          'Observation': formProps.Observation || 0,          
          'OtherTestsAdministered': formProps.OtherTestsAdministered || 0,
          'OtherTestsAdministeredNotes': formProps.OtherTestsAdministered ? formProps.OtherTestsAdministeredNotes : '',
        }        
      },
      'PatientEncounterServiceCodes': CPTcodes,
      'PatientEncounterDiagnosisCodes': ICDArray,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
    };
    // console.log('submit data =========',formData);
    let clinicalServiceCheckPermission = false;
    let testsAdministeredCheckermission = false;

    // Check directly formData
    if(formData.SessionNotes_DiagnosticEvaluation_SOAR.DiagnosticEvaluation_ClinicalService_SOAR) {
        let clinicalServiceCheck = formData.SessionNotes_DiagnosticEvaluation_SOAR.DiagnosticEvaluation_ClinicalService_SOAR;
        let testsAdministeredCheck = formData.SessionNotes_DiagnosticEvaluation_SOAR.DiagnosticEvaluation_TestsAdministered_SOAR;
       
        // For Present During Session
        if(clinicalServiceCheck.ClinicalInterview === 0 && clinicalServiceCheck.RecordsReview === 0 && clinicalServiceCheck.TestAdministration === 0 && clinicalServiceCheck.TestScoring === 0 && clinicalServiceCheck.ReportWriting === 0 
          && clinicalServiceCheck.FeedbackWithCaregiver === 0 && clinicalServiceCheck.ConsultationWithProvider === 0 && clinicalServiceCheck.OtherCareCoordination === 0 && clinicalServiceCheck.OtherPreparationAndInterpretation === 0 && clinicalServiceCheck.OtherClinicalService === 0) {
            clinicalServiceCheckPermission = false;
          this.setState({ isClinicalServiceCheckAllowed: false });
        } else {
          clinicalServiceCheckPermission = true;
          this.setState({ isClinicalServiceCheckAllowed: true });
        }

        // For Evidence-based Intervention Used
        if(this.state.isTestAdministeredSeviceCodes === true && testsAdministeredCheck.Mullen === 0 && testsAdministeredCheck.WISC_V === 0 && testsAdministeredCheck.ADOS_2 === 0 && testsAdministeredCheck.Vineland_3 === 0 && testsAdministeredCheck.BASC_3 === 0 && testsAdministeredCheck.SRS_2 === 0 && testsAdministeredCheck.ADI_R === 0 && testsAdministeredCheck.OtherClinicalInterview === 0 && testsAdministeredCheck.Observation === 0 && testsAdministeredCheck.OtherTestsAdministered === 0) {
          testsAdministeredCheckermission = false;
          this.setState({ isTestsAdministeredAllowed : false })
        } else {
          testsAdministeredCheckermission = true;
          this.setState({ isTestsAdministeredAllowed: true })
        }        
    }
  
    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;
    if(clinicalServiceCheckPermission === true && testsAdministeredCheckermission === true) {
      this.props.savePatientSoapAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
    } else {
      Alert.error('Please fill diagnostic evaluation details!', {
        position: 'bottom-right',
        effect: 'slide',
      });
    }
  }

  

  handleOpen = () => {
    this.setState({ open: true, soapPage: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpenCPT = () => {
    this.setState({ openCPT: true, soapPage: true });
  };
  handleCloseCPT = () => {
    this.setState({ openCPT: false });
  };
  handleOpenSign = () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true, soapPage: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  DiagnosisAlertClick = (e, index) => {
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ diagnosisArray: arr });
    }
  }
  handleRemoveDiagnosisClick = (e, index) => {
    Alert.warning('Are you sure you want to remove this diagnosis?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.DiagnosisAlertClick,
        id: index,
      },
    });
  }
  CPTCodeAlertClick = (e, data) => {
    if (data.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: data.AuthProcedureCPTLinkId,
      //   actionName: 'Delete',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let index = data.index;
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ CPTTableData: arr });
    }
  }
  handleRemoveCPTCodeClick = (e, data) => {
    Alert.warning('Are you sure you want to remove this service code?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.CPTCodeAlertClick,
        id: data,
      },
    });
  }
  renderDiagnosis() {
    if (this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).map((diagnosis, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="30%">{diagnosis.ICDCode}</TableRowColumn>
          <TableRowColumn width="70%">{diagnosis.Description ? diagnosis.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <TableRowColumn><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></TableRowColumn>
            : null} */}
        </TableRow>
      );
    });
  }
  renderCpt() {
    if (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).map((cpt, index) => {
      // let data = {
      //   index: index,
      //   AuthProcedureCPTLinkId: cpt.AuthProcedureCPTLinkId,
      // };
      return (
        <TableRow key={index}>
          <TableRowColumn>{cpt.ServiceCode ? cpt.ServiceCode : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.AttachedModifiers ? cpt.AttachedModifiers : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.Description ? cpt.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <td width="10%"><button onClick={(e) => this.handleRemoveCPTCodeClick(e, data)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></td>
            : null} */}
        </TableRow>
      );
    });
  }

  handleAddDiagnosis = (formValues) => {
    let diseaseDetails = extractDataFromArray(this.state.master_data.masterICD, formValues.ICDID);
    let arr = this.state.diagnosisArray;
    if (arr.indexOf(formValues) === -1) {
      arr.push({
        'DiagnosisDate': moment(formValues.DiagnosisDate).format(),
        'Description': diseaseDetails.description,
        'ICDCodeId': diseaseDetails.id,
        'ICDCode': diseaseDetails.code,
        'IsDeleted': false,
        'Id': 0,
      });
      this.setState({ diagnosisArray: arr });
    }
  }
  handleAddCPT = (formValues) => {
    if (formValues.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,
      //   actionName: 'Add',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let cptObj = extractDataFromArray(this.state.master_data.masterServiceCode, formValues.CPTID);
    let arr = this.state.CPTTableData;
    if (arr.indexOf(cptObj) === -1) {
      arr.push({
        'AuthProcedureCPTLinkId': formValues.AuthProcedureCPTLinkId,
        'AuthorizationNumber': formValues.AuthorizationNumber,
        'ServiceCodeId': cptObj.id,
        'ServiceCode': cptObj.serviceCode,
        'Description': cptObj.description,
        'IsDeleted': false,
        'Id': 0,
        'Modifier1': formValues.Modifier1 ? formValues.Modifier1 : null,
        'Modifier2': formValues.Modifier2 ? formValues.Modifier2 : null,
        'Modifier3': formValues.Modifier3 ? formValues.Modifier3 : null,
        'Modifier4': formValues.Modifier4 ? formValues.Modifier4 : null,
      });
      this.setState({ CPTTableData: arr });
    }
  }
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    switch (formProps.Signee) {
      case 1:
        data.id = this.state.EmployeeSign.id || null;
        data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ EmployeeSign: data });
        this.filter.isEmployeeSigned = true;
        this.saveEncounterSigns(data.id, data, null, null);
        break;
      case 2:
        data.id = this.state.ClientSign.id || null;
        data.Name = this.state.patientName;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ ClientSign: data });
        this.filter.isClientSigned = true;
        this.saveEncounterSigns(data.id, null, data, null);
        break;
      case 3:
        data.id = this.state.GuardianSign.id || null;
        data.Name = formProps.Guardian;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ GuardianSign: data });
        this.filter.isGuardianSigned = true;
        this.saveEncounterSigns(data.id, null, null, data);
        break;
      default:
        break;
    }

    this.setState({ isAllSigned: this.checkIsAllRequiredSigned() });
  }

  checkIsAllRequiredSigned() {
    let employee_Signed = true, client_signed = true, guardian_signed = true;
    if (this.state.signRequired.employee_sign) {
      if (this.filter.isEmployeeSigned) {
        employee_Signed = true;
      } else {
        employee_Signed = false;
      }
    }
    if (this.state.signRequired.client_sign) {
      if (this.filter.isClientSigned) {
        client_signed = true;
      } else {
        client_signed = false;
      }
    }
    if (this.state.signRequired.guardian_sign) {
      if (this.filter.isGuardianSigned) {
        guardian_signed = true;
      } else {
        guardian_signed = false;
      }
    }
    // finally check if all required are signed ...
    if (employee_Signed && client_signed && guardian_signed) {
      return true;
    } else {
      return false;
    }
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };


  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }
  
  render() {
    const { handleSubmit } = this.props;
    // const tableClass = classNames({
    //   'table': true,
    //   'table-striped': this.props.bordered,
    //   'table-bordered': this.props.bordered,
    //   'table-hover': true,
    //   'table-condensed': this.props.condensed,
    //   'customtable': true,
    // });
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {this.state.patient_id ?
          <PatientInfo patientId={this.state.patient_id} />
          : ''}
        {this.state.open ?
          <ProblemModal soapPage={this.state.soapPage} diagnosisArray={this.state.diagnosisArray} master_data={this.state.master_data} closeDialog={this.handleClose} handleAddDiagnosis={this.handleAddDiagnosis} />
          : null}
        {this.state.openCPT ?
          <CPTModal soapPage={this.state.soapPage} patientId={this.state.patient_id} dateOfService={this.state.DateOfService} cptArray={this.state.CPTTableData} master_CPT={this.state.master_data.masterServiceCode ? this.state.master_data.masterServiceCode : this.props.master_data.masterServiceCode} closeDialog={this.handleCloseCPT} handleAddCPT={this.handleAddCPT} />
          : null}
        {this.state.openSign ?
          <SignatureModal staffID={this.state.staffID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="row">
                <div className="col-12">
                  {this.state.isGenerateClaimAfterRendered ?
                    <div className={'alert alert-danger-soap update-pwd'}>
                      <strong>**YOU MUST SCROLL DOWN AND CLICK ON THE COMPLETE BUTTON TO SAVE YOUR CHANGES. <br/> CHANGES MAY NOT BE SAVED UNLESS YOU CLICK COMPLETE! <br/> IF THERE IS NO COMPLETE BUTTON THEN YOUR CHANGES HAVE BEEN SAVED AUTOMATICALLY. **</strong>
                    </div>
                    :
                    <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                   } 
                </div>
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Session Duration (In Mins):</b> <span>{this.state.timeDifference}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Diagnostic Evaluation Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-6 require mt-35'>
                  <div className="panel_title no_margin require mb-20">
                    <h5>Individuals present in the session:</h5><span style={{ color: 'red'}}>*</span>
                  </div>
                  <Field
                      name="IndividualsPresentId"         
                      //label="Rounding Rule"          
                      handleNewRequest={this.handleNewRequest}
                      options={this.state.master_data.masterDiagnosticEvaluationIndividualsPresent}
                      disabled={this.state.isSoapCompleted}
                      component={renderAutoCompleteSingleSelect}
                    />
                </div>
                <div className='col-sm-6'></div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Clinical Service Activities</h5><span style={{ color: 'red'}}>*</span>
                    {!this.state.isClinicalServiceCheckAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ClinicalInterview"
                    label="Clinical Interview"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RecordsReview"
                    label="Records Review"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TestAdministration"
                    label="Test Administration"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TestScoring"
                    label="Test Scoring"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ReportWriting"
                    label="Report Writing"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FeedbackWithCaregiver"
                    label="Feedback With Caregiver"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ConsultationWithProvider"
                    label="Consultation With Provider"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherCareCoordination"
                    label="Other Care Coordination"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherPreparationAndInterpretation"
                    label="Other Preparation And Interpretation"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherClinicalService"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherClinicalService &&
                  (<div className='col-sm-4 require'>
                  <Field
                    name="OtherClinicalServiceNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  {this.state.isTestAdministeredSeviceCodes === true ?
                    <div className="panel_title">
                      <h5>Tests Administered</h5><span style={{ color: 'red' }}>*</span>
                      {!this.state.isTestsAdministeredAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                    </div>
                    :
                    <div className="panel_title">
                      <h5>Tests Administered</h5>
                    </div>
                  }
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Mullen"
                    label="Mullen"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="WISC_V"
                    label="WISC-V"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ADOS_2"
                    label="ADOS-2"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Vineland_3"
                    label="Vineland-3"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BASC_3"
                    label="BASC-3"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SRS_2"
                    label="SRS-2"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ADI_R"
                    label="ADI-R"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherClinicalInterview"
                    label="Other Clinical Interview"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Observation"
                    label="Observation"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTestsAdministered"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTestsAdministered &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTestsAdministeredNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
          
            
            </form>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Diagnosis</h3>
                  <i className="flaticon flaticon-gym"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <CommonButton className="soapmodal_btn" label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
                </div>
                : null} */}
            </div>
            <div className="table-responsive mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                    <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    {/* {!this.state.isSoapCompleted ?
                      <TableHeaderColumn>Action</TableHeaderColumn>
                      : null} */}
                    {/* <TableHeaderColumn width="20%">Attach</TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderDiagnosis()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Service Codes</h3>
                  <i className="flaticon flaticon-interface-2"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <RaisedButton className="soapmodal_btn" label="Add Service Codes" primary={true} onTouchTap={this.handleOpenCPT} />
                </div>
                : null} */}
            </div>
            <div className="mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn>Service Code</TableHeaderColumn>
                    <TableHeaderColumn>Modifiers</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
                      <TableHeaderColumn width="10%">Action</TableHeaderColumn>
                      : null} */}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderCpt()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className={`col-sm-12 pt20 btn_rt ${this.state.showCompleteButton && 'scroll_btn'}`}>
                <CancelButton onTouchTap={this.handleCancel} />
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  : ''}

                {!this.state.isSoapCompleted ?
                  (<span>
                    {this.state.showCompleteButton ?
                      <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label="Complete" primary={true} disabled={!this.state.isAllSigned} onClick={handleSubmit(this.onCompleteSoap)} />
                      : <CommonButton onClick={handleSubmit(this.onSubmit)} className="ml-3" primary={true} label="Save" />
                    }
                  </span>)
                  : ''}
              </div>
            </div>

            {this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name ? this.state.ClientSign.Name : this.state.patientName} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
const selector = formValueSelector('soapForm');
SessionNotes_DiagnosticEvaluation_SOAR = reduxForm({
  form: 'soapForm',
  validate,
  enableReinitialize: true,
})(SessionNotes_DiagnosticEvaluation_SOAR);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let requiredGuardianSignForIndirectServicePermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_REQUIRED_GUARDIAN_SIGNATURE_FOR_INDIRECT_SERVICE')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;
  // End For Role Permission

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;
  let initialData = null;
  if (state.soap.get_soap) {
    let obj = state.soap.get_soap.data;
    if (obj.sessionNotes_DiagnosticEvaluation_SOAR) {
      initialData = {
        IndividualsPresentId: obj.sessionNotes_DiagnosticEvaluation_SOAR.individualsPresentId,        
        // DiagnosticEvaluation_ClinicalService_SOAR
        ClinicalInterview: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.clinicalInterview,
        RecordsReview: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.recordsReview,
        TestAdministration: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.testAdministration,
        TestScoring: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.testScoring,
        ReportWriting: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.reportWriting,
        FeedbackWithCaregiver: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.feedbackWithCaregiver,
        ConsultationWithProvider: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.consultationWithProvider,
        OtherCareCoordination: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.otherCareCoordination,
        OtherPreparationAndInterpretation: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.otherPreparationAndInterpretation,
        OtherClinicalService: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.otherClinicalService,
        OtherClinicalServiceNotes: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_ClinicalService_SOAR.otherClinicalServiceNotes,

        // DiagnosticEvaluation_TestsAdministered_SOAR
        Mullen: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.mullen,
        WISC_V: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.wisC_V,
        ADOS_2: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.adoS_2,
        Vineland_3: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.vineland_3,
        BASC_3: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.basC_3,
        SRS_2: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.srS_2,
        ADI_R: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.adI_R,
        OtherClinicalInterview: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.otherClinicalInterview,
        Observation: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.observation,
        OtherTestsAdministered: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.otherTestsAdministered,
        OtherTestsAdministeredNotes: obj.sessionNotes_DiagnosticEvaluation_SOAR.diagnosticEvaluation_TestsAdministered_SOAR.otherTestsAdministeredNotes,             
      };
    }
  }

  return {
    selectorOtherClinicalService: selector(state, 'OtherClinicalService'),
    selectorOtherTestsAdministered: selector(state, 'OtherTestsAdministered'),
    
    app_config: app_config,
    userLocationList: state.login.userLocationList,
    master_data: state.soap.master_data,
    patientData: state.patient.get_patient_byid,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,

    loading: state.soap.loading,
    appointment: state.soap.appointment,
    get_soap: state.soap.get_soap,
    saved_soap: state.soap.saved_soap && state.soap.saved_soap.data ? state.soap.saved_soap.data : null,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    deletePermission: deletePermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    requiredGuardianSignForIndirectServicePermission: requiredGuardianSignForIndirectServicePermission,
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,    
  };
}

export default connect(mapStateToProps, { getMasterData, getSoapAction, createClaimAction, getAppointmentById, savePatientSoapAction, updateServiceCodeBlockedUnits, getAppConfigList, getPatientProfileDetails, saveEncounterSigns, getGeoLocation })(SessionNotes_DiagnosticEvaluation_SOAR);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_SOAR/SessionNotes_DiagnosticEvaluation_SOAR.js